(function () {
	'use strict';
	angular.module('app.supplyChain')
		.controller('sotdController', sotdController);

	sotdController.$inject = ['$scope', 'supplierPerformanceSummaryService'];

	function sotdController($scope, supplierPerformanceSummaryService) {
		function getlateDeliveryDataBySupplier(factoryNdxs, supplierNdxs) {
			supplierPerformanceSummaryService.getLateDeliveryCauseDataBySupplier(factoryNdxs, supplierNdxs).then(function (data) {
				$scope.loading = false;
				$scope.initialLoad = false;

				if (!data || !data['data'] || !data['data'].length) {
					$scope.empty = true;
				} else {
					var groups = ['lateCustomerPos', 'lateVendorPos', 'earlyCustomerPos', 'earlyVendorPos'];
						
					var categories = [];
					var categoriesToId = {};
					angular.forEach(data.data, function (chartData) {
						categories.push(chartData.category);
						categoriesToId[chartData.category] = chartData.categoryNdx;
					});

					$scope.chartData = data.data;
					$scope.timeStampsByTimePeriod = data.timeStampsByTimePeriod;
					$scope.chartCategories = categories;
					$scope.chartGroups = groups;
					$scope.categoriesCount = categories.length;
					$scope.categoriesToId = categoriesToId;
					$scope.$broadcast('lateDeliveryCausesChartReady', null);
				}
			});
		}

		function init() {
			if (incomingData.factory && incomingData.supplierNdxs) {
				getlateDeliveryDataBySupplier(incomingData.factory, incomingData.supplierNdxs);
			}
		}

		init();
	}
})();
